import { mmFetchWithResponse } from './mmFetchWithResponse';

class PrepApi {
    constructor() {
        this.baseUrl = 'api/inventory-prep/v1';
    }

    async getPrepLocations({ facilityId }) {
        const url = `${this.baseUrl}/locations?facilityId=${facilityId}`;
        return mmFetchWithResponse(url);
    }

    async getPrepInventorySummary({ facilityId }) {
        const url = `${this.baseUrl}/locations/summary?facilityId=${facilityId}`;
        return mmFetchWithResponse(url);
    }

    async getPalletsInPrepLocations({ facilityId, locationName, type }) {
        let url = `${this.baseUrl}/pallets?facilityId=${facilityId}&type=${type}`;
        if (locationName) {
            url += `&locationName=${locationName}`;
        }
        return mmFetchWithResponse(url);
    }

    async prepPallet({
        casesRemaining,
        destinationLocationID,
        locationID,
        looseUnits,
        lotID,
        numRPCs,
        palletID,
        rpcsPerPallet,
        scrapReason,
        scrapUnits,
        unitsPerRPC,
        unitsRemaining,
    }) {
        const prepData = {
            lotID,
            locationID,
            palletID,
            numRPCs,
            rpcsPerPallet,
            unitsPerRPC,
            looseUnits,
            scrapUnits,
            scrapReason,
            destinationLocationID,
            casesRemaining,
            unitsRemaining,
        };
        const url = `${this.baseUrl}/pallet`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(prepData),
        });
    }

    async getPrepScrapReasons() {
        const url = `${this.baseUrl}/reasons/scrap`;
        return mmFetchWithResponse(url);
    }

    async getDestinationLocations({ facilityId, originLocationId }) {
        const url = `${this.baseUrl}/destination-locations?facilityId=${facilityId}&originLocationId=${originLocationId}`;
        return mmFetchWithResponse(url);
    }
}

export { PrepApi };
